import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filteredAssessmentsList: null
};

const filteredAssessments = createSlice({
    name: "filteredAssessments",
    initialState,
    reducers: {
        setFilteredAssessments(state, action) {
            state.filteredAssessmentsList = action.payload.filteredAssessments;
        }
    }
})

export const filteredAssessmentsAction = filteredAssessments.actions;
export default filteredAssessments;